import React from 'react';
import {
  FieldImageSetIcon,
  FieldSwitchIcon as Bool,
  FieldColorSmallIcon as Color,
  DateIcon as Date,
  EmailIcon as Email,
  AttachmentIcon as FileRef,
  ElementImageIcon as ImageRef,
  CMSInsertIcon as ItemRef,
  CMSSandwichIcon as ItemRefSet,
  LinkIcon as Link,
  MapIcon as Map,
  FieldNumberIcon as Number,
  FieldOptionIcon as Option,
  PhoneIcon as Phone,
  FieldTextIcon as PlainText,
  FieldPriceIcon as Price,
  FieldRichTextIcon as RichText,
  VideoIcon as Video,
  KeyIcon as Password,
  type BaseIconProps,
  RefreshIcon,
  ElementCollectionDefaultIcon,
} from '@packages/systems/spring';

const Icons = {
  Bool,
  Color,
  CommercePrice: Price,
  Date,
  Email,
  EnumOption: Option,
  FileRef,
  ImageRef,
  ItemRef,
  ItemRefSet,
  Link,
  Map,
  Number,
  Option,
  Phone,
  PlainText,
  RichText,
  Set: {
    ImageRef: FieldImageSetIcon,
    ExtFileRef: FileRef,
  },
  Video,
  Id: ElementCollectionDefaultIcon,
  SubscriptionPlan: Option,
  Password,
  Random: RefreshIcon,
} as const;

export const FieldListIcon = ({
  type,
  innerType,
  ...props
}: {
  type: string;
  innerType?: string;
} & BaseIconProps) => {
  const Icon =
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ImageRef: ForwardRefExoticComponent<BaseIconProps & RefAttributes<HTMLElement>>; readonly ExtFileRef: ForwardRefExoticComponent<...>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly Bool: ForwardRefExoticComponent<BaseIconProps & RefAttributes<HTMLElement>>; readonly Color: ForwardRefExoticComponent<BaseIconProps & RefAttributes<...>>; ... 19 more ...; readonly Password: ForwardRefExoticComponent<...>; }'.
    type === 'Set' && innerType ? Icons[type][innerType] : Icons[type];
  return Icon ? <Icon {...props} /> : null;
};
